/**
 * Leader assessment (head-nurse candidate rubric + score dashboard).
 *
 * Archived 2026-06-24 — set LEADER_ASSESSMENT_ENABLED to true and follow
 * archive/leader-assessment/README.md to restore routes, nav, and feature code.
 */
export const LEADER_ASSESSMENT_ENABLED = false;

export const LEADER_ASSESSMENT_PATH_SEGMENT = 'r3wk9mlq7nxv2zp8hq4nfkt6wm';
export const LEADER_ASSESSMENT_PATH = `/${LEADER_ASSESSMENT_PATH_SEGMENT}`;
export const LEADER_ASSESSMENT_DASHBOARD_PATH = '/leader-assessment/dashboard';

export function isLeaderAssessmentEnabled(): boolean {
  return LEADER_ASSESSMENT_ENABLED;
}

/** Safe login returnTo check — only honors leader path when feature is enabled. */
export function isLeaderAssessmentReturnPath(path: string | null | undefined): boolean {
  if (!LEADER_ASSESSMENT_ENABLED) return false;
  if (path == null || path === '') return false;
  let normalized = path.trim();
  try {
    normalized = decodeURIComponent(normalized);
  } catch {
    return false;
  }
  if (normalized.startsWith('//') || normalized.includes('://')) return false;
  normalized = normalized.replace(/\/+$/, '') || '/';
  return normalized === LEADER_ASSESSMENT_PATH;
}
